module.exports = __webpack_public_path__ + "static/media/traffic-light-go.5bfe8eaa.svg";